import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  label: {
    description: 'Label for the add importer of record input',
    defaultMessage: 'Add importer of record',
    id: 'jHNDi6',
  },
  placeholder: {
    description: 'Placeholder for the add importer of record input',
    defaultMessage: 'Select importer of record',
    id: 'OFFqKI',
  },
});
